var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechwork3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.916,
    height: 60.175,
    viewBox: "0 0 61.916 60.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15111",
    "data-name": "Group 15111",
    transform: "translate(-941.039 -208.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15110",
    "data-name": "Group 15110",
    transform: "translate(957.645 224.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41134",
    "data-name": "Path 41134",
    d: "M982.53,222.2a20.071,20.071,0,0,0-28.126,27.63Z",
    transform: "translate(-949.413 -216.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41135",
    "data-name": "Path 41135",
    d: "M956.479,251.386a20.056,20.056,0,0,0,27.633-27.147Z",
    transform: "translate(-944.935 -211.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41136",
    "data-name": "Path 41136",
    d: "M950.663,261.259h0a1.8,1.8,0,0,1,.024-2.545L992.4,217.93a1.8,1.8,0,0,1,2.545.024h0a1.8,1.8,0,0,1-.022,2.543l-41.712,40.784A1.8,1.8,0,0,1,950.663,261.259Z",
    transform: "translate(-950.147 -217.414)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 3.561,
    height: 13.324,
    rx: 0.932,
    transform: "translate(976.384 208.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 3.561,
    height: 13.324,
    rx: 0.932,
    transform: "translate(941.039 244.14) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 3.561,
    height: 13.324,
    rx: 0.932,
    transform: "translate(951.417 219.287) rotate(-41.485)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechwork3);
export default __webpack_public_path__ + "static/media/techwork3.0a27b6acfa3413a4c85c539b7169a34d.svg";
export { ForwardRef as ReactComponent };